import React, { useState, useEffect } from "react";
import {
    Card,Grid,FormControl,
    InputLabel,Select,MenuItem,OutlinedInput, Table, Button, TableRow, TableBody, TableCell, Container, TableContainer, TablePagination
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import Page from "../../components/Page";
import Scrollbar from "../../components/Scrollbar";
import {
    UserListHead
} from "../../sections/@dashboard/user";
import HeaderBreadcrumbs from "../../components/HeaderBreadcrumbs";
import {    
    FootballCancelMatchAction,
    GetUpcomingFootballMatchListAction,
} from "src/redux/actions/FootballAction";
import Loader from "src/components/Loader";
import { CronActivityAction } from "src/redux/actions/MatchAction";
import { DateRangePicker } from "rsuite";
import moment from "moment";

export default function FootballMatches() {
    const dispatch = useDispatch();
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(25);
    const [order, setOrder] = useState("asc");
    const [orderBy, setOrderBy] = useState("name");
    const [clickStatus, setClickStatus] = useState(false)
    const loadingSelector = useSelector(state => state.football.loading)
    const statusSelector = useSelector(state => state.football.match_status)
    const [state, setState] = useState({
        FootballListData: [],
        totalCountContestList: 0,
        logoImg: [],
        title: "",
        subtitle: "",
        dis_val: "",
    });

    const rStatusDetail={
        "1":"Fixture",
        "2":"Live",
        "3":"Result"
    }

    const colorRStatus={
        "1":"warning",
        "2":"error",
        "3":"success"
    }

    const selectorData = useSelector((state) => state);
    const FootballListData = useSelector(
        (state) => state?.football?.upcoming_football_match_list?.data?.data?.football_list
    );

    useEffect(() => {
        if (FootballListData !== undefined) {
            setState({
                ...state,
                FootballListData: FootballListData,
                totalCountContestList:
                    selectorData?.football?.upcoming_football_match_list?.data?.data?.total_count,
            });
        }
    }, [FootballListData]);

    useEffect(() => {
        dispatch(GetUpcomingFootballMatchListAction(page, rowsPerPage));
    }, [dispatch, page, rowsPerPage]);

    useEffect(() => {
        if (Object.keys(statusSelector).length > 0) {
            dispatch(GetUpcomingFootballMatchListAction(page, rowsPerPage));
        }
    }, [statusSelector, page, rowsPerPage])

    const handleRequestSort = (_, property) => {
        const isAsc = orderBy === property && order === "asc";
        setOrder(isAsc ? "desc" : "asc");
        setOrderBy(property);
    };

    const handleChangePage = (_, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value));
        setPage(0);
    };

    const activateMatch = (event, is_active, match_id) => {
        event.preventDefault();
        let sendData = {
            match_id: match_id,
            is_active: is_active,
        };
        dispatch(CronActivityAction(sendData));
    };

    const InactivateMatch = (event, is_active, match_id) => {
        event.preventDefault();
        let sendData = {
            match_id: match_id,
            is_active: is_active,
        };
        dispatch(CronActivityAction(sendData));
    };
    const CancelMatch = (event, is_cancel, match_id) => {
        
        event.preventDefault()
        let sendData = {
            match_id: match_id,
            r_status: is_cancel
        }
        dispatch(FootballCancelMatchAction(sendData))
    }

    const actionCreateButton = (event, activityKey, match_id) => {
        setClickStatus(true)
        event.preventDefault()
        let sendData = {
            match_id: match_id,
            activity_key: activityKey
        }
        dispatch(CronActivityAction(sendData))
    }

    return (
        <Page title="Upcoming Football Matches">
            {loadingSelector ? <Loader /> : null}
            <Container maxWidth="lg">
                <HeaderBreadcrumbs
                    heading="Upcoming Football Mathces"
                    links={[
                        { name: "Dashboard", href: "/dashboard/app" },
                        { name: "Upcoming Contest" },
                    ]}
                />

                <Card>
                    <Scrollbar>
                        <TableContainer sx={{ minWidth: 800 }}>
                            <Table>
                                <UserListHead
                                    order={order}
                                    orderBy={orderBy}
                                    headLabel={[
                                        { id: "c_no", label: "Sr no.", alignRight: false },
                                        { id: 'c_id', label: 'Match ID', alignRight: false },
                                        { id: "c_image", label: "Teams Title", alignRight: false },
                                        { id: "c_subtitle", label: "Subtitle", alignRight: false },
                                        { id: "c_time", label: "Date & Time", alignRight: false },
                                        // { id: "c_time", label: "Time", alignRight: false },
                                        { id: 'c_rstatus', label: 'Status', alignRight: false }
                                    ]}
                                    rowCount={state.totalCountContestList}
                                    // onRequestSort={handleRequestSort}
                                />
                                <TableBody>
                                    {FootballListData?.map((data, index) => (
                                        <TableRow key={index}>
                                            <TableCell
                                                component="th"
                                                scope="row"
                                            >
                                                {page * rowsPerPage + (index + 1)}.
                                            </TableCell>
                                            <TableCell component="th" scope="row"> {data.match_id}</TableCell>
                                            <TableCell
                                                component="th"
                                                scope="row"
                                            >{`${data.teama?.name} vs ${data.teamb?.name}`}
                                            </TableCell>
                                            <TableCell
                                                component="th"
                                                scope="row"
                                            >{data.league_name ? data.league_name : "-"}
                                            </TableCell>
                                            <TableCell
                                                component="th"
                                                scope="row"
                                            >
                                                {data.date_start_ist ? new Date(data.date_start_ist).toUTCString().split("GMT")[0] : "-"}
                                            </TableCell>
                                            {/* <TableCell
                                                component="th"
                                                scope="row"
                                            >
                                                {data.time.starting_at.time}
                                            </TableCell> */}
                                            <TableCell component="th" scope="row">
                                               <Button size="small" color={colorRStatus[data.rstatus]} onClick={(event) => actionCreateButton(event, 1, data.match_id)}>{rStatusDetail[data.rstatus]}</Button>
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Scrollbar>

                    <TablePagination
                        rowsPerPageOptions={[25, 50, 100, 150, 200]}
                        component="div"
                        count={state.totalCountContestList}
                        rowsPerPage={rowsPerPage}
                        page={page}
                        onPageChange={handleChangePage}
                        onRowsPerPageChange={handleChangeRowsPerPage}
                    />
                </Card>
            </Container>
        </Page>
    );
}
